import * as yup from "yup";

const personalSchema = yup.object().shape({
  name: yup.string().required("Name is required"),
  mail: yup.string().email("Invalid email").required("Email is required"),
  phone: yup
    .string()
    .required("Phone number is required")
    .test(
      "valid-phone",
      "Phone number must be between 10 and 15 digits",
      (value) => {
        return /^\d{10,15}$/.test(value);
      }
    ),
  pass: yup
    .string()
    .min(8, "Password must be at least 8 characters")
    .required("Password is required"),
  rePass: yup
    .string()
    .oneOf([yup.ref("pass"), null], "Passwords must match")
    .required("Confirm Password is required"),
});

const complexSchema = yup.object().shape({
  comName: yup.string().required("Complex Name is required"),
  comAddress: yup.string().required("Complex Address is required"),
  comUnit: yup
    .number()
    .typeError("Number of Units Must be a number")
    .positive("Must be a positive number")
    .integer("Must be an integer")
    .required("Number of Units is required"),
  comMail: yup.string().email("Invalid email").required("Email is required"),
  comPhone: yup
    .string()
    .nullable()
    .notRequired()
    .test(
      "valid-phone",
      "Phone number must be between 10 and 15 digits",
      (value) => {
        if (!value) return true;
        return /^\d{10,15}$/.test(value);
      }
    ),
});

const parkingSchema = yup
  .object()
  .shape({
    pSpot: yup
      .number()
      .positive("Must be a positive number")
      .typeError("Number of Parking Spots Must be a positive number")
      .integer("Must be an integer")
      .required("Number of Parking Spots is required"),
    pNumber: yup
      .number()
      .positive("Must be a positive number")
      .typeError("Tenant Parking Spaces Must be a positive number")
      .required("Tenant Parking Spaces required")
      .integer("Must be an integer"),
    pNumGuest: yup
      .number()
      .typeError("Guest Parking Must be a positive number")
      .positive("Must be a positive number")
      .integer("Must be an integer")
      .required("Guest Parking is required"),
    pAdmin: yup
      .number()
      .nullable()
      .transform((value, originalValue) =>
        originalValue === "" ? null : value
      )
      .typeError("Admin Parking must be a positive number")
      .min(0, "Admin Parking must be 0 or more")
      .integer("Must be an integer"),
    pHandcap: yup
      .number()
      .nullable()
      .transform((value, originalValue) =>
        originalValue === "" ? null : value
      )
      .typeError("Handicap Parking must be a positive number")
      .min(0, "Handicap Parking must be 0 or more")
      .integer("Must be an integer"),
  })
  .test(
    "parking-limit",
    "Total parking (Tenant + Guest + Admin + Handicap) cannot exceed total spots",
    function (values) {
      const { pSpot, pNumber, pNumGuest, pAdmin, pHandcap } = values;
      const totalUsed =
        (pNumber || 0) + (pNumGuest || 0) + (pAdmin || 0) + (pHandcap || 0);
      if (pSpot !== undefined && totalUsed > pSpot) {
        return this.createError({
          path: "pSpot",
          message: `Total parking (Tenant + Guest + Admin + Handicap) cannot exceed total Parking Spot. Available parking spots (${pSpot}).`,
        });
      }
      return true;
    }
  );

const finalSchema = yup.object().shape({
  ...personalSchema.fields,
  ...complexSchema.fields,
  ...parkingSchema.fields,
});

export const stepSchemas = [
  personalSchema,
  complexSchema,
  parkingSchema,
  finalSchema,
];
